import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT =
  "<p>Student engagement is a vital practice at St. Andrews World School, Indirapuram. We have built student engagement on the foundation of three pillars:</p>\n<ul>\n<li><strong>Academic Engagement:</strong> The students are assigned academic tasks that tap into their functioning skills and help them stay attentive and interested in the subject, and work towards solutions.</li>\n<li><strong>Intellectual Engagement:</strong> We use intellectual engagement opportunities to identify the interests, talents, and gifts of the students. Through challenges and purposeful tasks, we aim to cultivate intrinsic motivation in the students.</li>\n<li><strong>Socio-Economic Engagement:</strong> As important as it is to build a student-to-teacher relationship, it is equally important for the students to have connections with their peers. We have created innovative opportunities for the students to engage with their peers, be it in-person or remote.</li>\n</ul>";

const StudentEngagementPage = () => {
  const pageData = usePage('student-engagement', { content: DEFAULT_CONTENT });

  const title = 'Student Engagement';

  return (
    <>
      <SEO
        slug="student-engagement"
        title={title} description="Student engagement approach at St. Andrews World School, Indirapuram." keywords="Student Engagement, SAWS Indirapuram" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || '${process.env.PUBLIC_URL}/images/page-banners/admission-guidliness.jpg'} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">

            </div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10">
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default StudentEngagementPage;